import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';
import { UUID } from 'crypto';
import { createStowagePlanChange } from '../StowagePlanChangeFactory';
import { StowageChangeDataType } from 'src/types/ViewModel/Stowage/Enums/StowageChangeDataType';
import { createSequenceChangeValue } from './SequenceChangeUtil';

export const createBerthCallChangeData = (berthCall: RotationBerthCall): Partial<RotationBerthCall> => {
    return {
        imosBerthCallId: berthCall.imosBerthCallId,
        portCallGuid: berthCall.portCall?.portCallGuid ?? berthCall.portCallGuid,
        berthSequenceNumber: berthCall.berthSequenceNumber,
        dataSource: berthCall.dataSource,
        berthId: berthCall.berthId,
    };
};

export const createBerthCallOrderChange = (
    stowagePlanGuid: UUID,
    changeDataGuid: UUID,
    berthSequenceNumber: number,
    berthCallData?: RotationBerthCall
) => {
    const hasChangedSequence = createSequenceChangeValue(berthSequenceNumber, berthCallData, 'berthSequenceNumber');

    return createStowagePlanChange(stowagePlanGuid, changeDataGuid, StowageChangeDataType.RotationBerthCall, {
        berthSequenceNumber,
        hasChangedSequence,
    });
};
